import { render } from "./CompanyDescriptionCell.vue?vue&type=template&id=46fa1848"
import script from "./CompanyDescriptionCell.vue?vue&type=script&lang=js"
export * from "./CompanyDescriptionCell.vue?vue&type=script&lang=js"

import "./CompanyDescriptionCell.vue?vue&type=style&index=0&id=46fa1848&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__